<template>
  <!-- 选择会议室 -->
  <div class="list-layout-box" :class="[{'permit-nav':mobNavShow}]">
    <div class="top-fix-container">
      <back-route-hdr :back-mode="'func'" :cur-hash="'room'"
                      @handle-back="handleBack()"></back-route-hdr>
      <van-search v-model="searchText" show-action :placeholder="`搜索${roomTitle}`" class="bord-btm">
        <template #action></template>
      </van-search>
      <!-- 会议室筛选组件 -->
      <room-tree-filter :filter-doc="filterDoc" @handle-filter="handleFilter"></room-tree-filter>
    </div>

    <div v-if="roomList.length||notInit" class="room-cell-box ctn-mar-md">
      <p class="pad-lft-20">{{curTimeRange}}</p>

      <van-radio-group v-if="frequentRooms.length" v-model="checkRoomId">
        <van-cell-group :title="`常用${roomTitle}`" class="mar-btm frequent-room">
          <van-cell v-for="room in frequentRooms" :key="room.roomId"
                    :value="room.capacity+' 人'"
                    @click="checkRoomId=room.roomId">
            <template #title>
              <van-radio :name="room.roomId">
                <span class="custom-title">{{room.name}}</span>
              </van-radio>
              <p class="mar-top-0 mar-btm-0 text-lt text-sm mar-lft-20 pad-lft-10 line-hgt">{{room.locationInfo}}</p>
              <p v-show="room.deviceExceptionTip"
                 class="text-danger mar-top-0 mar-btm-0 text-sm mar-lft-20 line-hgt">* {{room.deviceExceptionTip}}</p>
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>

      <van-list v-model="loading" :finished="finished"
                finished-text="没有更多了" @load="onLoad">
        <van-radio-group v-model="checkRoomId">
          <van-cell-group v-for="(roomInfo, idx) in roomCells" :key="idx"
                          :title="roomInfo.location" class="mar-btm">
            <van-cell v-for="room in roomInfo.list" :key="room.roomId"
                      :value="'容纳 '+room.capacity+' 人'"
                      @click="checkRoomId=room.roomId">
              <template #title>
                <van-radio :name="room.roomId">
                  <span class="custom-title">{{room.name}}</span>
                </van-radio>
                <p v-show="room.deviceExceptionTip"
                   class="text-danger mar-top-0 mar-btm-0 text-sm mar-lft-20 line-hgt">* {{room.deviceExceptionTip}}</p>
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
      </van-list>
    </div>

    <div v-else-if="roomSuggestions.length" class="room-cell-box ctn-mar-md">
      <p class="text-center text-lt pad-ver">{{curTimeRange}} 暂无可用{{roomTitle}}</p>
      <van-cell-group title="其它时间">
        <van-cell v-for="ele in roomSuggestions" :key="ele.startTime" center
                  :title="`${ele.startTimeCN} - ${ele.endTimeCN}`"
                  :label="`此时间段有${ele.number}间${roomTitle}可用`">
          <template>
            <van-button type="primary" size="small" @click="changeTime(ele)">改为此时间</van-button>
          </template>
        </van-cell>
      </van-cell-group>
    </div>

    <div v-else>
      <empty-notice :image="'search'" :desc="`当天暂无可用${roomTitle}`"></empty-notice>
    </div>

    <div class="fixed-btm-box bord-top">
      <div class="pull-right pad-all-10">
        <van-button v-if="curDoc.roomId" size="small" class="mar-rgt-5"
                    @click="handleBack(true)">取消
        </van-button>
        <van-button v-if="curDoc.roomId" type="primary" size="small"
                    @click="handleBack()">确定
        </van-button>
        <van-button v-else icon="arrow-left" size="small" @click="handleBack()">返回</van-button>
      </div>
      <div class="pad-all">
        <span>{{curDoc.roomNum}}</span>
      </div>
    </div>
  </div>
</template>

<script>
  import {meetingRoom} from "../../../../../server";
  import RoomTreeFilter from '../../room/RoomTreeFilter'
  import {frontConfirm, checkShowPermit} from "../../../../../tools/utils";
  import {momentFormat} from "../../../../../config/common";

  const formatTime = (time) => moment(time).format(momentFormat.time);

  export default {
    components: {RoomTreeFilter},
    props: {
      curDoc: Object,
      startTime: Number,
      endTime: Number,
      numberOfPeople: Number,
      isPeriodic: Boolean,
    },
    data() {
      return {
        searchText: "",
        roomList: [],
        roomSuggestions: [],
        filterDoc: null,
        frequentRooms: [],
        pageInfo: {
          pageSize: 20,
          pageNum: 1,
          pages: 1,
        },
        finished: false,
        loading: false,
        notInit: true,
      }
    },
    computed: {
      roomTitle() {
        return this.$store.state.formTitles.meetingRoom
      },
      numberOfPeopleTitle() {
        return this.$store.state.formTitles.numberOfPeople
      },
      // 组装时间
      curTimeRange() {
        return `${formatTime(this.startTime)} - ${formatTime(this.endTime)}`
      },
      // 渲染会议室数据
      roomCells() {
        const obj = {};
        // console.log('roomCells', this.roomList);
        this.roomList.forEach(r => {
          if (obj[r.locationInfo]) {
            obj[r.locationInfo].push(r)
          } else {
            obj[r.locationInfo] = [r]
          }
        });
        return Object.keys(obj).map(k => ({
          location: k,
          list: obj[k]
        }))
      },
      checkRoomId: {
        get: function () {
          return this.curDoc && this.curDoc.roomId;
        },
        // 确认更改后的会议室是否满足会议需求
        set: function (roomId) {
          if (this.curDoc.roomId === roomId) return;
          const data = this.roomList.concat(this.frequentRooms).find(r => r.roomId === roomId) || {};
          if (this.numberOfPeople && data.capacity < this.numberOfPeople) {
            frontConfirm({
              title: "容量不足",
              msg: `${this.numberOfPeopleTitle}超过${this.roomTitle}容量，是否继续？`
            }, () => {
              this.$emit('change-info', data)
            })
          } else {
            this.$emit('change-info', data)
          }
        },
      },
      comFilterData() {
        const filter = {
          ...(this.filterDoc || {}),
          startTime: this.startTime,
          endTime: this.endTime,
          textField: this.searchText
        };
        if (this.isPeriodic) {
          filter.allowPeriodic = true
        }
        return filter
      },
      mobNavShow() {
        const permissionList = this.$store.state.permissionList || [];
        return checkShowPermit(permissionList, this.permitsMap.mobNav)
      }
    },
    watch: {
      searchText(val) {
        this.handleRoomList();
      },
    },
    created() {
      this.getFrequentRoom();
    },
    methods: {
      onLoad() {
        this.getRoomList(this.pageInfo.pageNum++)
      },
      handleRoomList() {
        this.pageInfo.pageNum = 1;
        this.roomList = [];
        this.roomSuggestions = [];
        this.finished = false;
        this.getFrequentRoom();
        this.onLoad()
      },
      // 常用会议室，单独查找
      getFrequentRoom() {
        meetingRoom.frequentRoom(this, {
          queryFilter: this.comFilterData,
          mid: this.$route.params.mid || "",
        }).then(({searchFrequentRoom: data = {}}) => {
          this.frequentRooms = (data.roomEdges || []).map(e => ({
            ...e.room,
            locationInfo: (e.room.locationList || []).map(e => e.name).join('-')
          }))
        }).catch(err => {
        });
      },
      // 查询会议室
      getRoomList(pageNum = 1) {
        !this.loading && UILoader.load();
        meetingRoom.filterRoom(this, {
          queryFilter: {
            ...this.comFilterData,
            pageNum,
            pageSize: this.pageInfo.pageSize,
          },
          mid: this.$route.params.mid || "",
        }).then(({searchRoom: data = {}}) => {
          this.loading = false;
          UILoader.unload();
          // 会议室懒加载
          const {roomEdges, pageInfo} = data;
          this.roomList = this.roomList.concat((roomEdges || []).map(e => ({
            ...e.room,
            locationInfo: (e.room.locationList || []).map(e => e.name).join('-'),
          })));
          this.pageInfo.pages = Math.ceil((pageInfo.total || 0) / this.pageInfo.pageSize);
          if (!pageInfo.total || pageNum >= this.pageInfo.pages) {
            this.finished = true
          }
          // 会议室推荐
          this.roomSuggestions = (data.roomSuggestions || []).map(e => {
            return {
              ...e,
              startTimeCN: formatTime(e.startTime),
              endTimeCN: formatTime(e.endTime),
            }
          });
          if (this.finished && !this.roomList.some(r => r.roomId === this.curDoc.roomId)) {
            this.$emit('change-info', {})
          }
          this.notInit = false;
        }).catch(err => {
          this.loading = false;
          this.finished = true;
          UILoader.unload();
          // console.log(err);
          vtToast(err.message)
        });
      },
      handleFilter(data) {
        this.filterDoc = data;
        this.handleRoomList();
      },
      handleBack(clear) {
        this.$emit('change-info', clear ? {} : null)
      },
      changeTime(ele) {
        frontConfirm({msg: `是否确认修改时间段为 ${ele.startTimeCN} - ${ele.endTimeCN}？`}, () => {
          this.$emit('change-time', ele);
          Promise.resolve().then(() => {
            this.handleRoomList();
          });
        })
      },
    }
  }
</script>

<style scoped>
</style>
